import {
  FINGERPRINTING_CONFIG_LOADED,
  FINGERPRINTING_CONFIG_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import { arriveNotice } from '../noticeActions';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { setFaviconLoading, setFaviconDefault } from '../faviconActions';

// Reducer corresponding actions
function fingerprintingConfigLoaded(config) {
  return {
    type: FINGERPRINTING_CONFIG_LOADED,
    payload: { config },
  };
}

function fingerprintingConfigClear() {
  return { type: FINGERPRINTING_CONFIG_CLEAR };
}

// API
async function getFingerprintingConfigApi(token) {
  const response = await api.get({
    path: 'fingerprinting_config',
    token,
    version: 'v3',
  });
  return response.json();
}

async function updateFingerprintingConfigApi(token, body) {
  const response = await api.patch({
    path: 'fingerprinting_config',
    token,
    body,
    version: 'v3',
  });
  return response.json();
}

// Helpers
async function fetchFingerprintingConfig(dispatch, token) {
  try {
    const config = await getFingerprintingConfigApi(token);
    dispatch(fingerprintingConfigLoaded(config));
  } catch (e) {
    if (e.name !== 'AbortError') {
      dispatch(arriveNotice(e.message));
    }
  } finally {
    dispatch(setFaviconDefault());
    dispatch(setFetchLoaderReset());
  }
}

async function saveFingerprintingConfig(dispatch, token, body) {
  try {
    await updateFingerprintingConfigApi(token, body);
    dispatch(arriveNotice('Fingerprinting configuration saved successfully', 'ok'));
    await fetchFingerprintingConfig(dispatch, token);
  } catch (e) {
    if (e.name !== 'AbortError') {
      dispatch(arriveNotice(e.message));
    }
  } finally {
    dispatch(setSubmissionLoaderReset());
  }
}

// Public component actions
export function initiateFetchFingerprintingConfigRequest() {
  return async (dispatch, getState) => {
    const {
      auth: { token },
      favicon: { faviconStatus },
      fetchLoader: { dataLoading },
    } = getState();

    if (!dataLoading) {
      dispatch(setFetchLoaderLoading());
    }

    if (faviconStatus !== 'loading') {
      dispatch(setFaviconLoading());
    }

    await fetchFingerprintingConfig(dispatch, token);
  };
}

export function clearFingerprintingConfigRequest() {
  return (dispatch) => {
    dispatch(fingerprintingConfigClear());
  };
}

export function updateFingerprintingConfigRequest(body) {
  return async (dispatch, getState) => {
    const {
      auth: { token },
      fetchLoader: { submissionLoading },
    } = getState();

    if (!submissionLoading) {
      dispatch(setSubmissionLoaderLoading());
    }

    await saveFingerprintingConfig(dispatch, token, body);
  };
}
